import './init'
import { createApp } from 'vue/dist/vue.esm-bundler';
import { Loader } from './lex-web-ui';
import LexWeb from './components/LexWeb.vue'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@fortawesome/fontawesome-free/css/all.css'

const vuetify = createVuetify({
  components,
  directives,
})

// Initialize the Loader
const lexWebUi = new Loader();

// Create the Vue app directly with LexWeb component
const app = createApp(LexWeb)

app.use(vuetify)
app.use(lexWebUi.store)

// Make $lexWebUi available globally
app.config.globalProperties.$lexWebUi = lexWebUi;

app.mount('#lex-app')